import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    h18Url: '',
    forumUrl: '',
    memberUrl: '',
    hubUrl: '',
    exchangeUrl: '',
    urlQuery: '',
    loginFallbackUrl: null,
};

export const urlSlice = createSlice({
    name: 'url',
    initialState,
    reducers: {
        setH18Url: (state, action) => {
            state.h18Url = action.payload;
        },
        setForumUrl: (state, action) => {
            state.forumUrl = action.payload;
        },
        setMemberUrl: (state, action) => {
            state.memberUrl = action.payload;
        },
        setHubUrl: (state, action) => {
            state.hubUrl = action.payload;
        },
        setExchangeUrl: (state, action) => {
            state.exchangeUrl = action.payload;
        },
        setUrlQuery: (state, action) => {
            state.urlQuery = action.payload;
        },
        setLoginFallbackUrl: (state, action) => {
            state.loginFallbackUrl = action.payload;
        },
    },
});

export const urlState = (state) => state.url;

export const {
    setExchangeUrl,
    setH18Url,
    setForumUrl,
    setMemberUrl,
    setHubUrl,
    setUrlQuery,
    setLoginFallbackUrl,
} = urlSlice.actions;

export default urlSlice.reducer;
